import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import type { GenericDisplayProps } from "./DisplayComponent"

type Props = GenericDisplayProps<string | number>

const TextDisplay: ReactiveComponent<Props> = (props) => {
	return () => (props.value === null ? "" : String(props.value))
}

export default defineComponent(TextDisplay, inferProps<Props>())
